import React from 'react';
import ReactDOM from 'react-dom/client';
import { SeoProvider } from './seo/SeoProvider';
import { initWebVitals } from './analytics/webVitals';
import './index.css';
import './i18n';
import i18n from 'i18next';
import App from './App';

const rootElement = document.getElementById('root');

const renderApp = () => {
  const app = (
    <React.StrictMode>
      <SeoProvider>
        <App />
      </SeoProvider>
    </React.StrictMode>
  );

  if (rootElement.hasChildNodes()) {
    // Limpiar artefactos del pre-rendering antes de hydrate
    document.querySelectorAll('body > iframe').forEach(el => el.remove());
    rootElement.classList.remove('loaded');

    try {
      ReactDOM.hydrateRoot(rootElement, app, {
        onRecoverableError: (err) => {
          // Hydration mismatches menores — React se recupera solo, solo loguear
          if (process.env.NODE_ENV === 'development') {
            console.warn('Hydration mismatch:', err.message);
          }
        },
      });
    } catch (err) {
      // Error catastrófico — fallback a createRoot
      console.warn('Hydration failed, falling back to createRoot');
      rootElement.textContent = '';
      const root = ReactDOM.createRoot(rootElement);
      root.render(app);
    }
  } else {
    const root = ReactDOM.createRoot(rootElement);
    root.render(app);
  }

  if (navigator.userAgent !== 'ReactSnap') {
    initWebVitals();
  }
};

if (i18n.isInitialized) {
  renderApp();
} else {
  i18n.on('initialized', renderApp);
}